import {getRequest} from './api'
import {Message} from 'element-ui'

export const isNotNullORBlank = (...args)=> {
  for (let i = 0; i < args.length; i++) {
    let argument = args[i];
    if (argument == null || argument == '' || argument == undefined) {
      Message.warning({message: '数据不能为空!'})
      return false;
    }
  }
  return true;
}
export const initMenu = (router, store)=> {
  if (store.state.routes.length > 0) {
    return;
  }
  getRequest("/api/menu/getMenusByHrId").then(resp=> {
    if (resp && resp.status == 200) {
      if (resp.data.length == 0){
        Message.warning("请联系管理员配置菜单权限！")
      }else {
        let fmtRoutes = formatRoutes(resp.data);
        router.addRoutes(fmtRoutes);
        store.commit('initMenu', fmtRoutes);
        // store.dispatch('connect');
      }
    }
  })
}
export const formatRoutes = (routes)=> {
  let fmRoutes = [];
  routes.forEach(router=> {
    let {
      path,
      component,
      name,
      meta,
      iconCls,
      children
    } = router;
    if (children && children instanceof Array) {
      children = formatRoutes(children);
    }
    const resolvedComponent = component || 'Home';
    let fmRouter = {
      path: path,
      component(resolve){
        if (resolvedComponent.startsWith("Home")) {
          require(['../components/' + resolvedComponent + '.vue'], resolve)
        } else if (resolvedComponent.startsWith("Sys")) {
          require(['../components/system/' + resolvedComponent + '.vue'], resolve)
        } else if (resolvedComponent.startsWith("Approve")) {
          require(['../components/approve/' + resolvedComponent + '.vue'], resolve)
        } else {
          require(['../components/Home.vue'], resolve)
        }
      },
      name: name,
      iconCls: iconCls,
      meta: meta,
      children: children
    };
    fmRoutes.push(fmRouter);
  })
  return fmRoutes;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js